import React from 'react';
import ContentWrapper from '../atoms/ContentWrapper';
import Pagehead from '@oberoninternal/travelbase-ds/components/section/Pagehead';
import { Route, useRouteMatch } from 'react-router-dom';
import NotFound from './NotFound';
import { PartnerParams } from '../../entities/PartnerParams';
import HistoryScreen from './visitorRegister/HistoryScreen';
import { FormattedMessage, useIntl } from 'react-intl';
import { LocalizedSwitch } from '../atoms/LocalizedSwitch';

const VisitorRegister = () => {
    const match = useRouteMatch<PartnerParams>();
    const { formatMessage } = useIntl();
    return (
        <ContentWrapper>
            <Pagehead title={formatMessage({ defaultMessage: 'Nachtregister' })}>
                <FormattedMessage defaultMessage="Bekijk hier het nachtregister van de boekingen die zijn gemaakt via Travelbase." />
            </Pagehead>
            <LocalizedSwitch>
                <Route path={`${match.path}/`} exact component={HistoryScreen} />
                <Route component={NotFound} />
            </LocalizedSwitch>
        </ContentWrapper>
    );
};

export default VisitorRegister;
